import notificationSoundUrl from "@/assets/audios/JoinMC-wood.wav";

const SOUND_VOLUME = 0.5; // 默认音量，避免提示音过响。
const MIN_PLAY_INTERVAL = 1500; // 连续通知的最小播放间隔，防止消息风暴导致连续响铃。

let audio = null; // 单例音频实例，复用后无需重复加载。
let lastPlayedAt = 0; // 上次尝试播放的时间，用于节流。

/**
 * 懒加载通知提示音实例。
 * 创建时即触发资源加载，后续播放无需等待网络。
 * @returns {HTMLAudioElement|null} 音频实例，非浏览器环境返回 null
 */
function getAudio() {
  if (typeof window === "undefined") return null;
  if (audio) return audio;

  try {
    audio = new Audio(notificationSoundUrl);
    audio.preload = "auto";
    audio.volume = SOUND_VOLUME;
    // 部分浏览器仅设置 preload 不会主动拉取资源，显式调用 load 提前下载。
    audio.load();
  } catch (error) {
    // 音频实例创建失败时只禁用声音，不影响通知卡片展示。
    audio = null;
  }

  return audio;
}

/**
 * 提前加载通知提示音，应用启动时调用可避免首次播放等待资源。
 * @returns {void}
 */
export function preloadNotificationSound() {
  getAudio();
}

/**
 * 播放站内通知提示音。
 * 首次进入页面若尚未产生用户交互，浏览器会拦截有声播放，此时静默失败。
 * @returns {void}
 */
export function playNotificationSound() {
  const instance = getAudio();
  if (!instance) return;

  const now = Date.now();
  if (now - lastPlayedAt < MIN_PLAY_INTERVAL) return;
  lastPlayedAt = now;

  try {
    instance.currentTime = 0;
  } catch (error) {
    // 音频元数据尚未加载完成时，currentTime 赋值可能失败，忽略并继续播放。
  }

  try {
    const playResult = instance.play();
    if (playResult && typeof playResult.catch === "function") {
      // 自动播放被浏览器拦截时忽略，不影响通知卡片展示。
      playResult.catch(() => {});
    }
  } catch (error) {
    // 播放失败只影响提示音。
  }
}
